import { render, staticRenderFns } from "./PredictedTransaction.vue?vue&type=template&id=670c8e54&scoped=true&"
import script from "./PredictedTransaction.vue?vue&type=script&lang=js&"
export * from "./PredictedTransaction.vue?vue&type=script&lang=js&"
import style0 from "./PredictedTransaction.vue?vue&type=style&index=0&id=670c8e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c8e54",
  null
  
)

export default component.exports